import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as RolesActions } from 'store/ducks/roles';

import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Configs/Roles/components';

class Edit extends Component {
  state = {
    data: {
      title: '',
      alias: '',
      description: '',
    },

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Configurações', to: '/configs' },
      { name: 'Permissões', to: '/configs/roles' },
      { name: 'Detalhes', to: '' },
    ],
  };

  componentDidMount() {
    this.props.getRoleRequest(this.handleGetId())
  }

  componentDidUpdate(oldProps) {
    const { payment } = this.props;

    if (oldProps.payment.loading && !payment.loading) {
      this.setState({
        data: {
          title: payment.data.title,
          alias: payment.data.alias,
          description: payment.data.description,
        },
      });
    }
  }

  handleGetId = () => {
    const match = matchPath(this.props.location.pathname, { path: '/configs/roles/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.state;

    this.props.updateRoleRequest(this.handleGetId(), {
      ...form,
    });
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form data={data} saving={update.loading} onChange={this.handleChange} onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

const mapState = state => ({
  payment: state.roles.detail,
  update: state.roles.update,
})

const mapActions = dispatch => bindActionCreators(RolesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
